module.exports = __webpack_public_path__ + "img/4door_driving.4278b036.svg";